/**
 * Single owner of the status color vocabulary (success / error / running /
 * warning) for inline styles.
 *
 * The status variables these entries reference (`--success`, `--error`,
 * `--warning`, `--success-bg`, `--warning-bg`) ARE now defined in
 * `static/assets/styles.css`, per theme — so the theme wins and the hex
 * fallbacks here only apply if the stylesheet fails to load. Route every
 * inline status color through this module anyway: hand-spelled copies drift
 * invisibly (a site writing `var(--success, #27ae60)` renders its own green
 * whenever the fallback is what shows). `statusColorOwnership.test.ts` fails
 * CI on new copies.
 *
 * Defined theme tokens (`--warn`, `--accent`, `--muted`, the palette scales)
 * are a separate vocabulary owned by `styles.css` `:root` — sites using
 * those unadorned are theming, not spelling status shades, and stay as-is.
 */
export const STATUS_COLORS = {
  success: '#16a34a',
  error: '#dc2626',
  running: '#2563eb',
  warning: '#d97706',
} as const;

export const STATUS_THEME_COLORS = {
  success: `var(--success, ${STATUS_COLORS.success})`,
  error: `var(--error, ${STATUS_COLORS.error})`,
  running: `var(--accent, ${STATUS_COLORS.running})`,
  warning: `var(--warning, ${STATUS_COLORS.warning})`,
} as const;

/** Pale background tints paired with the status colors (badges, banners). */
export const STATUS_TINT_COLORS = {
  success: 'var(--success-bg, #f0fdf4)',
  warning: 'var(--warning-bg, #fffbeb)',
} as const;
